import { render, staticRenderFns } from "./CardMenu.vue?vue&type=template&id=98f5bfe2&scoped=true&"
import script from "./CardMenu.vue?vue&type=script&lang=ts&"
export * from "./CardMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CardMenu.vue?vue&type=style&index=0&id=98f5bfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f5bfe2",
  null
  
)

export default component.exports